import * as React from "react";
const SvgStorySeenMclaren = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 165, height: 165, viewBox: "0 0 165 165", fill: "none", ...props }, /* @__PURE__ */ React.createElement("circle", { opacity: 0.16, cx: 82.5, cy: 82.5, r: 81.5, stroke: "white", strokeWidth: 2 }));
export default SvgStorySeenMclaren;
